import type { StoreFeatureConfig } from '../type';

export const store: Partial<StoreFeatureConfig> = {
    isStoreInfoApiSupported: true,
};
